import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty, isNil, isNull } from 'lodash'
import axios from 'axios'
import { Modal, Icon, Table, Avatar } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../../utils/hooks'
import { fetchUserAnnouncementDetail } from '../../../modules/userAnnouncement'
import { HERO_TYPE_MESSAGE } from '../../../utils/constants'
import Lightbox from "react-image-lightbox";
import "../../../../node_modules/react-image-lightbox/style.css";

const UserAnnouncementView = (props) => {
  const dispatch = useDispatch()
  const { visible, onCancel, formData } = props
  const [announceLocation, setAnnounceLocation] = useState('')
  const [current , setCurrent] = useState('')

  const { userAnnouncementObj } = useSelector(
    (state) => ({
      userAnnouncementObj: state.userAnnouncement.userAnnouncementObj
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      if (formData && !isNil(formData) && !isEmpty(formData)) {
        await dispatch(fetchUserAnnouncementDetail(formData.id))

        const res = await axios.get(
          'https://maps.googleapis.com/maps/api/geocode/json?latlng=' +
            formData.latitude +
            ',' +
            formData.longitude +
            '&key=AIzaSyBZbBLFNB3c9y3NpdDqwCaxUlUvNN9Fe7M'
        )
        if (
          !isNil(res.data) &&
          !isNil(res.data.results) &&
          !isEmpty(res.data.results)
        ) {
          setAnnounceLocation(res.data.results[0].formatted_address)
        }
      }
    }
    fetch()
  }, [formData])

  const getStoreBy = (storeBySelf, storeByHero) => {
    if (_.isNil(storeBySelf) || _.isNil(storeByHero)) {
      return '-'
    } else if (storeBySelf && storeByHero) {
      return 'ไปขายที่ร้าน หรือ รถมารับซื้อ'
    } else if (storeBySelf && !storeByHero) {
      return 'ไปขายที่ร้าน'
    } else if (!storeBySelf && storeByHero) {
      return 'รถมารับซื้อ'
    }
    return '-'
  }
  const handleClickImage = (e, image) => {
    e && e.preventDefault();
    setCurrent(image)
  };

  const handleCloseModal = e => {
    e && e.preventDefault();
    setCurrent('')
  };

  const materialColumns = [
    {
      title: 'รายการวัสดุ',
      dataIndex: 'materialName',
      key: 'materialNameColumns',
      render: (text, record) => (
        <span>
          <Avatar
            key={text + Math.random()}
            shape="square"
            src={record.imageUrl}
            size={43}
            style={{ marginRight: 10 }}
          />
          {text}
        </span>
      )
    },
    {
      title: 'รูปถ่าย',
      dataIndex: 'binImage',
      align: 'right',
      key: 'binImage',
      render: (row) => (
        <div>
          <Avatar src={row} alt="" size={64} onClick={e => handleClickImage(e, row)}/>        
          {current && (
          <Lightbox mainSrc={current} onCloseRequest={handleCloseModal} />
        )}
        </div>
      )
    },
    {
      title: 'ชิ้น',
      dataIndex: 'volume',
      align: 'right',
      key: 'volume1'
    },
    {
      title: 'น้ำหนัก',
      align: 'right',
      key: 'weight1',
      dataIndex: 'weight',
      render: (text) => <span>{text} KG.</span>
    }
  ]

  const getInterestedMaterial = (isInterested, heroOfferItemDto) => {
    if (isInterested) {
      const result = heroOfferItemDto.filter(
        (heroOffer) => heroOffer.offerFlag === true
      )
      return result.map((material, index) => {
        return (
          <Avatar
            key={material + index}
            shape="square"
            src={material.materialImage}
            size={40}
          />
        )
      })
    } else {
      const result = heroOfferItemDto.filter(
        (heroOffer) => heroOffer.offerFlag === false
      )
      return result.map((material, index) => {
        return (
          <Avatar
            key={material + index}
            shape="square"
            src={material.materialImage}
            size={40}
          />
        )
      })
    }
  }

  const getHeroReason = (heroOfferStatusAdminDto) => {
    const {
      reason1,
      reason2,
      reason3,
      reason4,
      reason5,
      reason6,
      reason7,
      reason8
    } = heroOfferStatusAdminDto
    let reason = ''
    if (!isNull(reason1)) {
      reason = reason.concat(`${reason1}, `)
    }
    if (!isNull(reason2)) {
      reason = reason.concat(`${reason2}, `)
    }
    if (!isNull(reason3)) {
      reason = reason.concat(`${reason3}, `)
    }
    if (!isNull(reason4)) {
      reason = reason.concat(`${reason4}, `)
    }
    if (!isNull(reason5)) {
      reason = reason.concat(`${reason5}, `)
    }
    if (!isNull(reason6)) {
      reason = reason.concat(`${reason6}, `)
    }
    if (!isNull(reason7)) {
      reason = reason.concat(`${reason7}, `)
    }
    if (!isNull(reason8)) {
      reason = reason.concat(`${reason8}, `)
    }
    return reason
  }

  const heroColumns = [
    {
      title: 'ฮีโร่ที่สนใจ',
      dataIndex: 'heroOfferStatusAdminDto.heroName',
      key: 'heroName',
      render: (text, record) => (
        <span>
          <Avatar
            key={text}
            src={record.heroOfferStatusAdminDto.heroAvatar}
            size={40}
            style={{ marginRight: 10 }}
          />
          {text}
        </span>
      )
    },
    {
      title: 'ประเภทฮีโร่',
      dataIndex: 'heroOfferStatusAdminDto.heroType',
      key: 'heroType',
      render: (text, record) => (
        <span>{text ? HERO_TYPE_MESSAGE[text] : text}</span>
      )
    },
    {
      title: 'วิธีส่งต่อ',
      key: 'storeByHero-storeBySelf',
      dataIndex: 'heroOfferStatusAdminDto.storeByHero',
      render: (text, record) => (
        <span>
          {getStoreBy(record.heroOfferStatusAdminDto.storeBySelf, text)}
        </span>
      )
    },
    {
      title: 'วัสดุที่รับ',
      key: 'heroOfferItemDto.true',
      dataIndex: 'heroOfferItemDto',
      render: (heroOfferItemDto) => (
        <div>{getInterestedMaterial(true, heroOfferItemDto)}</div>
      )
    },
    {
      title: 'วัสดุที่ไม่รับ',
      key: 'heroOfferItemDto.false',
      dataIndex: 'heroOfferItemDto',
      render: (heroOfferItemDto) => (
        <div>{getInterestedMaterial(false, heroOfferItemDto)}</div>
      )
    }
  ]

  const heroReasonColumns = [
    {
      title: 'ฮีโร่ที่ไม่สนใจ',
      dataIndex: 'heroOfferStatusAdminDto.heroName',
      key: 'notHeroName',
      render: (text, record) => (
        <span>
          <Avatar
            key={text}
            src={record.heroOfferStatusAdminDto.heroAvatar}
            size={40}
            style={{ marginRight: 10 }}
          />
          {text}
        </span>
      )
    },
    {
      title: 'ประเภทฮีโร่',
      dataIndex: 'heroOfferStatusAdminDto.heroType',
      key: 'notHeroType',
      render: (text, record) => (
        <span>{text ? HERO_TYPE_MESSAGE[text] : text}</span>
      )
    },
    {
      title: 'เหตุผล',
      key: 'heroReason',
      dataIndex: 'heroOfferStatusAdminDto',
      render: (text, record) => (
        <span>{getHeroReason(record.heroOfferStatusAdminDto)}</span>
      )
    }
  ]

  return (
    <Modal
      width={1000}
      destroyOnClose={true}
      title={'รายละเอียดประกาศ'}
      visible={visible}
      onCancel={onCancel}
      footer={null}>
      <strong>วิธีส่งต่อ:</strong>{' '}
      {getStoreBy(formData.storeBySelf, formData.storeByHero)}
      <br />
      <strong>สถานที่:</strong> {announceLocation}{' '}
      <a
        href={
          'https://www.google.com/maps/search/?api=1&query=' +
          formData.latitude +
          '%2C' +
          formData.longitude
        }
        target="_blank"
        rel="noreferrer">
        <Icon type="eye" theme="filled" style={{ color: '#1890ff' }} />
      </a>
      <Table
        bordered
        dataSource={userAnnouncementObj.announcementMaterialList}
        columns={materialColumns}
        size="small"
        rowKey={(record) => {
          return record.id
        }}
        style={{ marginTop: '20px' }}
        pagination={false}
      />
      <Table
        bordered
        dataSource={userAnnouncementObj.interestedHero}
        columns={heroColumns}
        size="small"
        rowKey={(record) => {
          return record.id
        }}
        style={{ marginTop: '20px' }}
        pagination={false}
      />
      <Table
        bordered
        dataSource={userAnnouncementObj.notInterestedHero}
        columns={heroReasonColumns}
        size="small"
        rowKey={(record) => {
          return record.id
        }}
        style={{ marginTop: '20px' }}
        pagination={false}
      />
    </Modal>
  )
}

UserAnnouncementView.propTypes = {
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default UserAnnouncementView



// WEBPACK FOOTER //
// ./src/pages/UserAnnouncement/UserAnnouncementView/index.js